import { createSlice } from "@reduxjs/toolkit";

const partRequests = createSlice({
  name: "partRequests",
  initialState: {
    allPartRequest: {
      count: 0,
      rows: [],
    },
    newPartRequests: {
      count: 0,
      rows: [],
    }, activePartRequests: {
      count: 0,
      rows: [],
    },
    completedPartRequests: {
      count: 0,
      rows: [],
    },
    archivedPartRequests: {
      count: 0,
      rows: [],
    },
    partRequestDetails: null,
    isAllLoaded: false,
    isNewLoaded: false,
    isActiveLoaded: false,
    isCompletedLoaded: false,
    isArchivedLoaded: false,
    isDetailsLoaded: false,
  },
  reducers: {
    getAllPartRequest(state) {
      state.isAllLoaded = false;
    },
    setAllPartRequest(state, action) {
      state.allPartRequest = action.payload;
      state.isAllLoaded = true;
    },
    getNewPartRequests(state) {
      state.isNewLoaded = false;
    },
    setNewPartRequests(state, action) {
      state.newPartRequests = action.payload;
      state.isNewLoaded = true;
    },
    getActivePartRequests(state) {
      state.isActiveLoaded = false;
    },
    setActivePartRequests(state, action) {
      state.activePartRequests = action.payload;
      state.isActiveLoaded = true;
    },
    getCompletedPartRequests(state) {
      state.isCompletedLoaded = false;
    },
    setCompletedPartRequests(state, action) {
      state.completedPartRequests = action.payload;
      state.isCompletedLoaded = true;
    },
    getArchivedPartRequests(state) {
      state.isArchivedLoaded = false;
    },
    setArchivedPartRequests(state, action) {
      state.archivedPartRequests = action.payload;
      state.isArchivedLoaded = true;
    },
    getPartRequestDetails(state) {
      state.isDetailsLoaded = false;
    },
    setPartRequestDetails(state, action) {
      state.partRequestDetails = action.payload;
      state.isDetailsLoaded = true;
    },
  },
});

export const {
  getAllPartRequest,
  setAllPartRequest,
  getNewPartRequests,
  setNewPartRequests,
  getActivePartRequests,
  setActivePartRequests,
  getCompletedPartRequests,
  setCompletedPartRequests,
  getArchivedPartRequests,
  setArchivedPartRequests,
  getPartRequestDetails,
  setPartRequestDetails,
} = partRequests.actions;

export default partRequests.reducer;
